import script from "./DrUniversityMatchups.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrUniversityMatchups.vue?vue&type=script&setup=true&lang=ts"

import "./DrUniversityMatchups.vue?vue&type=style&index=0&id=18be1935&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18be1935"]])

export default __exports__